import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { AiMappingController } from "../useAiMappingController";
import AiMappingResults from "./AiMappingResults";

export function AiMappingAreaCreationControls({ controller }: { controller: AiMappingController }) {
  return (
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="center"
      px={0.5}
      sx={{ flexBasis: "100%" }}
    >
      <MDTypography
        variant="caption"
        color="text"
        sx={{ fontSize: 9, lineHeight: 1, mb: 0.25, whiteSpace: "nowrap" }}
      >
        Select AI Measure Area
      </MDTypography>
      <MDButton
        size="small"
        variant="outlined"
        color="info"
        disabled={controller.busy || !!controller.activeTask}
        onClick={() => controller.startDrawing("POLYGON")}
        sx={{ minWidth: 0, px: 0.75, py: 0.25, fontSize: 10, minHeight: 24 }}
      >
        Define AI Map Area
      </MDButton>
    </MDBox>
  );
}

export default function AiMappingRunAreaEditor({
  controller,
}: {
  controller: AiMappingController;
}) {
  const selectedArea =
    controller.areas.find((area) => area.id === controller.selectedAreaId) ?? null;
  if (!selectedArea) return null;
  return (
    <MDBox
      p={1}
      data-testid="ai-mapping-run-area-editor"
      sx={{ border: "2px solid #93c5fd", borderRadius: "16px", bgcolor: "#f8fbff" }}
    >
      <MDTypography
        variant="button"
        fontWeight="medium"
        color="info"
        display="block"
        mb={0.75}
        noWrap
      >
        Selected Area: {selectedArea.name || "Untitled Area"}
      </MDTypography>
      <AiMappingResults controller={controller} />
    </MDBox>
  );
}
